import { agreementTemplateFormToQuery as formToQuery } from './agreementTemplateFormToQuery';
import { agreementTemplateQueryToForm as queryToForm, agreementTemplateQueryToFormItem as queryToFormItem } from './agreementTemplateQueryToForm';

export default { formToQuery, queryToForm, queryToFormItem };
